import React from 'react'

export function TimelineBtn(props) {
    return (
        <div className="col-sm-6">
            <div className={props.BtnClass}>{props.BtnName}</div>
        </div>
    )
}